import {ChangeEvent} from 'react';
import {Checkbox, Form, Modal, withForm} from '@innowise-group/ui-kit';
import {Controller, useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

export enum DeleteRoomConfirmationFields {
  DeleteAdjacentDoors = 'deleteAdjacentDoors',
}

export type DeleteRoomConfirmationValues = {
  deleteAdjacentDoors: boolean;
  confirmationText?: string;
  cancelText?: string;
  onCancel?: () => void;
};

type DeleteRoomConfirmationProps = {
  onSubmit: (values: DeleteRoomConfirmationValues) => void;
  initialValues: DeleteRoomConfirmationValues;
};

const DeleteRoomConfirmationForm = ({onSubmit, initialValues}: DeleteRoomConfirmationProps) => {
  const {deleteAdjacentDoors, confirmationText, cancelText, onCancel} = initialValues;
  const {
    control,
    handleSubmit,
    formState: {errors},
  } = useFormContext();
  const {t} = useTranslation();

  return (
    <Form.Container onSubmit={handleSubmit(onSubmit)}>
      <Form.Layout layoutType="vertical">
        <Controller
          defaultValue={deleteAdjacentDoors}
          name={DeleteRoomConfirmationFields.DeleteAdjacentDoors}
          control={control}
          render={({field: {onChange, value}}) => (
            <Form.Field error={errors[DeleteRoomConfirmationFields.DeleteAdjacentDoors]}>
              <Checkbox
                checked={value}
                onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.checked)}
                position="left"
              >
                {t('modals.deleteRoomDoorsCheckbox')}
              </Checkbox>
            </Form.Field>
          )}
        />
        <Modal.Actions
          noVerticalPadding={true}
          actions={[
            {
              title: confirmationText || t('modals.deleteRoomConfirmationText'),
              onClick: () => {
                handleSubmit(onSubmit)();
              },
              highlighted: true,
              type: 'button',
            },
            {
              title: cancelText || t('buttons.cancel'),
              onClick: () => {
                onCancel?.();
              },
              type: 'button',
            },
          ]}
        />
      </Form.Layout>
    </Form.Container>
  );
};

export default withForm(DeleteRoomConfirmationForm);
